import { useEffect, useState } from "react";

// Mounts an inline Ionic overlay (IonModal, IonToast, IonAlert…) only while
// it is open, and unmounts it after it has dismissed.
//
// Why: Ionic React portals inline overlays into whichever <ion-app> exists
// when the overlay component is *constructed*. Every /app page renders its
// own IonApp, and during a client-side page change the outgoing page's
// ion-app is still in the DOM while the incoming page renders. A permanently
// mounted overlay is therefore portaled into the old ion-app, which is
// removed a moment later, and flipping isOpen afterwards presents nothing.
// Constructing the overlay at open time (after the switch has settled)
// targets the live ion-app. `render` outlives `isOpen` briefly so the close
// animation still plays.
export default function FreshOverlay({ as: Overlay, isOpen, onDidDismiss, children, ...rest }) {
  const [render, setRender] = useState(isOpen);
  useEffect(() => { if (isOpen) setRender(true); }, [isOpen]);
  if (!render) return null;
  return (
    <Overlay
      isOpen={isOpen}
      onDidDismiss={(e) => { setRender(false); onDidDismiss?.(e); }}
      {...rest}
    >
      {children}
    </Overlay>
  );
}
